import { RETURN_PATH_KEY } from "@constants";
import { getCLILoginToken } from "@utils";

import { getSafeRedirect } from "./getSafeRedirect";

const getReturnPathParam = () => {
  const params = new URLSearchParams(window.location.search);
  return getSafeRedirect(params.get(RETURN_PATH_KEY));
};

const getReturnPath = () => {
  const returnPath = getReturnPathParam();
  const isCLILoginPending = getCLILoginToken();

  if (!!isCLILoginPending) return "/login"; // we must circle back to /login in order to activate the pending CLI token

  if (returnPath) return returnPath;

  return window.location.pathname === "/login"
    ? "/manage/" // avoid login loop
    : window.location.pathname;
};

const popupCenter = (
  url: string,
  title: string,
  windowWidth: number,
  windowHeight: number
) => {
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : // eslint-disable-next-line no-restricted-globals
      screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : // eslint-disable-next-line no-restricted-globals
      screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - windowWidth) / 2 / systemZoom + dualScreenLeft;
  const top = (height - windowHeight) / 2 / systemZoom + dualScreenTop;
  const newWindow = window.open(
    url,
    title,
    `
    scrollbars=yes,
    width=${windowWidth / systemZoom},
    height=${windowHeight / systemZoom},
    top=${top},
    left=${left}
    `
  );

  // @ts-ignore
  if (window.focus) newWindow.focus();

  return newWindow;
};

export const openLoginPopup = ({
  provider_id,
  provider_type,
}: {
  provider_id: string;
  provider_type: string;
}) => {
  const params = new URLSearchParams();
  params.set("provider_id", provider_id);
  params.set("provider_type", provider_type);

  const newWindow = popupCenter(
    `/login-popup?${params.toString()}`,
    "login-popup",
    500,
    600
  );
  if (newWindow) {
    var timer = setInterval(function () {
      if (newWindow.closed) {
        clearInterval(timer);
        window.location.href = getReturnPath();
        // TODO: try to make it client side
      }
    }, 300);
  }
};
